// ===================== Imports =====================
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import * as FaIcons from "react-icons/fa";
import Modal from "react-bootstrap/Modal";

import AxiosInstance from "../Axios/AxiosInstance";
import { hasJWTToken } from "../Account/RouteGuard";

import "../../Assets/Styles/robot.css";
import "../../Assets/Styles/Form.css";


// ===================================================
// Navigate to Edit Page (Stores block ID in session)
// ===================================================
const editBlock = (blockId) => {
    sessionStorage.setItem("editBlockId", blockId);
    window.location.href = `#/plant-block?pid=${blockId}`;
};


// ===================================================
// Custom Styles for DataTable
// ===================================================
const customStyles = {
    table: { style: { border: "none", fontSize: "100%" } },
    rows: { style: { backgroundColor: "transparent" } },
    headCells: { style: { fontWeight: "700", fontSize: "110%" } },
};


// ===================================================
// Main Component
// ===================================================
export const SearchBlock = () => {

    // ---------- Component State ----------
    const [searchTerm, setSearchTerm] = useState("");
    const [blockData, setBlockData] = useState([]);
    const [filteredBlocks, setFilteredBlocks] = useState([]);

    // Delete Modal State
    const [selectedBlockId, setSelectedBlockId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);


    // ===================================================
    // Table Columns
    // ===================================================
    const columns = [
        {
            name: "ID",
            selector: (row) => (
                <a className="alink" onClick={() => editBlock(row.block_id)}>
                    {row.block_id}
                </a>
            ),
            sortable: true,
        },
        { name: "Plant Name", selector: (row) => row.plant_name, sortable: true },
        { name: "Block Name", selector: (row) => row.block_name, sortable: true },
        { name: "Date", selector: (row) => row.block_added_date, sortable: true },
        {
            name: "Delete",
            selector: (row) => (
                <a className="alink" onClick={() => handleShowDelete(row.block_id)}>
                    Delete
                </a>
            ),
        },
    ];


    // ===================================================
    // Modal Handlers
    // ===================================================
    const handleShowDelete = (blockId) => {
        setSelectedBlockId(blockId);
        setShowDeleteModal(true);
    };

    const handleCloseDelete = () => {
        setSelectedBlockId(null);
        setShowDeleteModal(false);
    };


    // ===================================================
    // Delete Record (API Call)
    // ===================================================
    const deleteRecord = async () => {
        try {
            const userId = sessionStorage.getItem("user_id");

            await AxiosInstance.get(
                `/PlantBlock/DeleteBlock?bid=${selectedBlockId}&uid=${userId}&pn=DeleteBlock`
            );

            await fetchBlockData();      // refresh table
            handleCloseDelete();
        } catch (error) {
            console.error("Delete Error:", error);
        }
    };


    // ===================================================
    // Search Handler � filters table results
    // ===================================================
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (!value) {
            setFilteredBlocks(blockData);
            return;
        }

        const results = blockData.filter((item) =>
            Object.values(item).some(
                (val) =>
                    typeof val === "string" &&
                    val.toLowerCase().includes(value.toLowerCase())
            )
        );

        setFilteredBlocks(results);
    };


    // ===================================================
    // Fetch Block Data (API Call)
    // ===================================================
    const fetchBlockData = async () => {
        try {
            const blockId = "1";
            const userId = sessionStorage.getItem("user_id");

            const res = await AxiosInstance.get(
                `/PlantBlock?bid=${blockId}&uid=${userId}&pn=SearchBlock&sn=SearchAllBlock`
            );

            setBlockData(res.data || []);
            setFilteredBlocks(res.data || []);
        } catch (error) {
            console.error("Fetch Error:", error);
        }
    };


    // ===================================================
    // Load data on component mount
    // ===================================================
    useEffect(() => {
        fetchBlockData();
    }, []);


    // ===================================================
    // Redirect if user is not authenticated
    // ===================================================
    if (!hasJWTToken()) {
        window.location.href = "#/Login";
        return null;
    }


    // ===================================================
    // Render UI
    // ===================================================
    return (
        <div className="page-container" style={{ backgroundColor: "white" }}>

            <p>&nbsp;</p>

            <h2 className="form-title">
                <FaIcons.FaSearch /> Search Block
            </h2>

            {/* ===================================================
                Header Row (Add New Block + Search Box)
            =================================================== */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px"
                }}
            >
                {/* Add New Block Button */}
                <a className="btndelete" href="#/plant-block">
                    Add New Block
                </a>

                {/* Search Box */}
                <input
                    type="text"
                    className="search-input"
                    placeholder="Search Results"
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </div>

            {/* ===================== Data Table ===================== */}
            <DataTable
                columns={columns}
                data={filteredBlocks}
                pagination
                highlightOnHover
                customStyles={customStyles}
            />


            {/* ===================== Delete Confirmation Modal ===================== */}
            <Modal show={showDeleteModal} centered onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Block</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Are you sure you want to delete Block ID:
                    <strong> {selectedBlockId}</strong>?
                </Modal.Body>

                <Modal.Footer>
                    <a className="btndelete" onClick={deleteRecord}>
                        Delete
                    </a>
                    <a className="btncancel" onClick={handleCloseDelete}>
                        Cancel
                    </a>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default SearchBlock;
